import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const Modal = ({
    open,
    onClose,
    title,
    kicker,
    children,
    footer,
    width,
    closable = true,
}) => {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === 'Escape' && closable) onClose?.();
        };
        window.addEventListener('keydown', onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [open, onClose, closable]);

    if (!open) return null;

    const handleBackdrop = closable ? onClose : undefined;

    return createPortal(
        <div className="fs fs-modal" role="dialog" aria-modal="true">
            <div className="fs-modal-backdrop" onClick={handleBackdrop} />
            <div
                className="fs-modal-panel"
                style={width ? { maxWidth: width } : undefined}
                onClick={(e) => e.stopPropagation()}
            >
                {(title || kicker || closable) && (
                    <div className="fs-modal-head">
                        <div>
                            {kicker ? <span className="kicker">{kicker}</span> : null}
                            {title ? <h2>{title}</h2> : null}
                        </div>
                        {closable && (
                            <button
                                type="button"
                                className="fs-modal-close"
                                aria-label="Close"
                                onClick={onClose}
                            >
                                ✕
                            </button>
                        )}
                    </div>
                )}
                <div className="fs-modal-body">{children}</div>
                {footer ? <div className="fs-modal-foot">{footer}</div> : null}
            </div>
        </div>,
        document.body,
    );
};

export default Modal;
